export default {
  '{0} - {1} of {2}': '{0} - {1} of {2}',
  '{0} unread notifications': '{0} unread notifications',
  'Mark order {0} as paid': 'Mark order {0} as paid',
  'Refund order {0}': 'Refund order {0}',
  '{0} per item': '{0} per item',
  'Shipped by {0}': '',
  '{0} in stock': '{0} in stock',
  'Used {0} times': 'Used {0} times',
  '{0} saved': '{0} saved',
  '{0} deleted': '{0} deleted',
  'approved': 'Approved',
  'placed': 'Placed',
  'processing': 'Processing',
  'shipped': 'Shipped',
  'refunded': 'Refunded',
  'on_hold': 'On hold',
  'canceled': 'Canceled',
  'completed': 'Completed',
  'created': 'Created',
  '{0} items': '{0} items'
}
